import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  addVendorMaterialGroup,
  getVendorMaterialGroups,
  updateVendorMaterialGroup,
  deleteVendorMaterialGroup,
} from "./vendorMaterialGroupAPI";

const initialState = {
  loading: false,
  vendorMaterialGroupList: [],
  pagination: {},
};

const actions = {
  CREATE_VENDOR_MATERIAL_GROUP: "vendorMaterialGroup/CREATE_VENDOR_MATERIAL_GROUP",
  GET_VENDOR_MATERIAL_GROUPS: "vendorMaterialGroup/GET_VENDOR_MATERIAL_GROUPS",
  UPDATE_VENDOR_MATERIAL_GROUP: "vendorMaterialGroup/UPDATE_VENDOR_MATERIAL_GROUP",
  DELETE_VENDOR_MATERIAL_GROUP: "vendorMaterialGroup/DELETE_VENDOR_MATERIAL_GROUP",
};

export const createVendorMaterialGroupThunk = createAsyncThunk(
  actions.CREATE_VENDOR_MATERIAL_GROUP,
  async (payload) => {
    const response = await addVendorMaterialGroup(payload);
    return response;
  }
);

export const getVendorMaterialGroupsThunk = createAsyncThunk(
  actions.GET_VENDOR_MATERIAL_GROUPS,
  async (payload) => {
    const response = await getVendorMaterialGroups(
      payload?.page,
      payload?.per_page,
      payload?.search
    );
    return response;
  }
);

export const updateVendorMaterialGroupThunk = createAsyncThunk(
  actions.UPDATE_VENDOR_MATERIAL_GROUP,
  async ({ id, ...payload }) => {
    const response = await updateVendorMaterialGroup(id, payload);
    return response;
  }
);

export const deleteVendorMaterialGroupThunk = createAsyncThunk(
  actions.DELETE_VENDOR_MATERIAL_GROUP,
  async (id) => {
    const response = await deleteVendorMaterialGroup(id);
    return response;
  }
);

export const vendorMaterialGroupSlice = createSlice({
  name: "vendorMaterialGroup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createVendorMaterialGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createVendorMaterialGroupThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Vendor Material Group created successfully!");
        } else {
          message.error(msg || "Failed to create Vendor Material Group.");
        }
      })
      .addCase(createVendorMaterialGroupThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to create Vendor Material Group.");
      });

    builder
      .addCase(getVendorMaterialGroupsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorMaterialGroupsThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, data } = action.payload;
        if (success) {
          state.vendorMaterialGroupList = data?.data || [];
          state.pagination = data?.pagination || {};
        } else {
          message.error(msg || "Failed to fetch Vendor Material Groups.");
        }
      })
      .addCase(getVendorMaterialGroupsThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to fetch Vendor Material Groups.");
      });

    builder
      .addCase(updateVendorMaterialGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVendorMaterialGroupThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Vendor Material Group updated successfully!");
        } else {
          message.error(msg || "Failed to update Vendor Material Group.");
        }
      })
      .addCase(updateVendorMaterialGroupThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to update Vendor Material Group.");
      });

    builder
      .addCase(deleteVendorMaterialGroupThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteVendorMaterialGroupThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Vendor Material Group deleted successfully!");
        } else {
          message.error(msg || "Failed to delete Vendor Material Group.");
        }
      })
      .addCase(deleteVendorMaterialGroupThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to delete Vendor Material Group.");
      });
  },
});

export default vendorMaterialGroupSlice.reducer;
